import { Vue, Component, Prop } from 'vue-property-decorator';
import { PartnersModel } from '@/models/console/partners';
import { consoleAPI } from '@/providers/apis/console/console';
import { PARTNERS_TYPE } from '@/utils/constants';
import { sortByProperty } from '@/utils/utils';

@Component({
    name: 'collaborators-list',
})

export default class CollaboratorsList extends Vue {

    // ------------------------------------------------------------------
    // Properties

    // @Prop({default:[]})
    private collaboratorsList: any = [];

    private headerFields: any = [
        {
            key: 'name',
            sortable: true,
        },
        {
            key: 'total',
            label: 'Total Partners',
        },
    ];

    private isLoading: boolean = false;


    // ------------------------------------------------------------------
    // Hooks

    private created() {
       this.initializer();
    }

    // ------------------------------------------------------------------
    // Actions

    private onRowSelected(item: any) {
        this.$router.push(`/console/partners/list/type/${item.type}`);
    }

    private onGoBack() {
        this.$router.push(`/console`);
    }


    // ------------------------------------------------------------------
    // Methods

    private initializer() {
        this.isLoading = true;
        consoleAPI.fetchModifiedPartnerList().then((partners) => {
            Object.keys(partners).forEach((collaborators) => {
                const partnerDetails = PARTNERS_TYPE.find((item) => item.type === collaborators);
                if (partnerDetails) {
                    const createCollab = {
                        name: partnerDetails.name,
                        type: collaborators,
                        total: (partners[collaborators]).length || 0,
                        list: partners[collaborators],
                    };
                    this.collaboratorsList.push(createCollab);
                }
                this.isLoading = false;
            });
            sortByProperty(this.collaboratorsList, 'name', 'ASC');
        });
    }

}
